export const activeHotDeals = (routes, now = Date.now()) => (Array.isArray(routes) ? routes : []).filter(route => {
  if (!route.hot || route.active === false) return false;
  if (!route.offer_ends) return true;
  const deadline = new Date(route.offer_ends).getTime();
  return Number.isFinite(deadline) && deadline > now;
});